(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AutoFaxDialogController', AutoFaxDialogController);

    AutoFaxDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'AutoFax', 'ContactAddress', 'CoreService'];

    function AutoFaxDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                     AutoFax, ContactAddress, CoreService) {
        var vm = this;

        vm.autoFax = entity;
        vm.clear = clear;
        vm.save = save;
        vm.contactAddresses = ContactAddress.faxeable({id: CoreService.getCurrentFacility().id});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.autoFax.id !== null) {
                AutoFax.update(vm.autoFax, onSaveSuccess, onSaveError);
            } else {
                AutoFax.save(vm.autoFax, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:autoFaxUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
